<template>
  <nav class="flex items-center justify-center gap-2 mt-4">
    <button
      class="px-3 py-1 border-0 rounded-md"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
    >
      ← {{ $t('common.prev') }}
    </button>

    <button
      v-for="page in visiblePages"
      :key="page"
      class="px-3 py-1 border-0 rounded-md"
      :class="{ 'bg-primary text-white': page === currentPage }"
      @click="changePage(page)"
    >
      {{ page }}
    </button>

    <button
      class="px-3 py-1 border-0 rounded-md"
      :disabled="currentPage === paginatorInfo.lastPage"
      @click="changePage(currentPage + 1)"
    >
        {{ $t('common.next') }} →
    </button>
  </nav>
</template>

<script setup>
import { usePagination } from '@jinkosoft/pagination'

const props = defineProps({
  paginatorInfo: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['pageChange'])

const { currentPage, visiblePages, changePage } = usePagination(props, emit)
</script>